import React, { Component } from "react";
import customFetch from "./apicall/api";
import { withRouter } from "react-router";
import { useHistory, Redirect } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import {
  logout,
  chkapiinput,
  checkTime,
  checkBanner,
  bannertimer,
  generateId,
} from "./Utility";
import { ThemeContext } from "../context/IsLoader";
import { Switch, Space } from "antd";
const generate_Id1 = generateId(10);
class CollectionReceipt extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      hh_id: "",
      us_id: "",
      isLoaded: false,
      isDisable: false,
      Overdue_Amount: "",
      Overdue_Charges: "",
      Overdue_Amount: "",
      Current_Demand_Amount: "",
      Borrower_Name: "",
      Household_id: "",
      Loan_os: "",
      Charges_os: "",
      balance: "",
      isErrOpen: false,
      api_error_message: "",
      isSpin: false,
      flag: 0,
      isLogout: false,
      LoanDetail: [],
      isLoan: false,
      time_flag: 0,
    };
    this.processTransfer = this.processTransfer.bind(this);
  }

  processTransfer(event) {
    if (parseInt(this.state.balance) == 0 || parseInt(this.state.balance) < 0) {
      event.currentTarget.setAttribute("data-toggle", "modal");
      event.currentTarget.setAttribute("data-target", "#disp_msg");
    }
  }

  titleCase(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  // logout() {
  //   localStorage.clear();
  //   this.props.history.push("/");
  // }

  componentDidMount() {
    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        this.setState({ isSpin: false, flag: 1 }); // Set flag to 1 if accessed from Android
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        console.log("AndroidInterface->", data);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }

    document.title = "Collection Recipt";
    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    if (checkTime() !== false) {
      this.state.time_flag = 1;
      this.setState({ isSpin: false, maintaenance: checkTime() });
    } else {
      this.setState({ isSpin: true });
    }
    if (checkBanner() != false) {
      const interval = setInterval(() => {
        this.setState({
          banner_timer: bannertimer(),
        });
      }, 1000);
      this.setState({
        maintaenanceBanner: true,
        maintaenanceBannerText: checkBanner(),
      });
    }
    this.state.hh_id = this.props.location.state.hh_id;
    this.state.us_id = this.props.location.state.in_user_id;
    this.state.Loan_os = this.props.location.state.Loan_os;
    this.state.Charges_os = this.props.location.state.Charges_os;
    this.state.balance = this.props.location.state.balance;

    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      this.setState({ isLogout: true, isSpin: false });
      return;
      // localStorage.clear();
      // this.props.history.push("/");
    }

    const { api_token, household_id } =
      (this.props.location && this.props.location.state) || {};
    /*Check if data is null then logout*/
    var arr = [uid, household_id];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }
    // AT-2143 | AT-2179 | Ankur Makavana | 13-07-2023 | conver post method to get method
    const params = {
      in_userid: uid,
      in_household_id: household_id,
    };

    const queryParams = new URLSearchParams(params).toString();
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/households?" + queryParams, {
      method: "GET",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((json) => {
        console.log(json);
        for (let index = 0; index < json.length; index++) {
          this.setState({
            isSpin: false,
            Overdue_Amount: json[index]["Overdue_Amount"],
            Overdue_Charges: json[index]["Overdue_Charges"],
            Overdue_Amount: json[index]["Overdue_Amount"],
            Current_Demand_Amount: json[index]["Current_Demand_Amount"],
            Borrower_Name: json[index]["Borrower_Name"],
            Household_id: json[index]["Household_ID"],
          });
        }
        //console.log("Invalid-token",json.Invalid_token)
        //  if(json.Invalid_token===true){
        //     localStorage.clear();
        //     this.props.history.push('/');
        //  } else {
        //     this.setState({
        //         isLoaded: true,
        //         items: json
        //     });
        // }
        if (json.length === 0) {
          this.setState({ isDisable: true });
        }
        this.setState({
          isLoaded: true,
          items: json,
        });
      })
      .catch((error) => {
        console.log("error", error)
        this.setState({
          isSpin: false,
        });
      });
  }
  handleChangebal(e) {
    const { api_token, household_id } =
      (this.props.location && this.props.location.state) || {};
    if (e) {
      this.setState({ isSpin: true, isLoan: true });
      /*Check if data is null then logout*/
      var arr = [household_id];
      var chkdata = chkapiinput(arr);
      if (chkdata === false) {
        this.setState({ isSpin: false });
        setTimeout(function() {
          logout();
        }, 2000);
      }
      /*Check if data is null then logout End*/
      // AT-2143 | AT-2179 | Ankur Makavana | 13-07-2023 | conver post method to get method
      const params = {
        household_id: household_id,
      };
      const queryParams = new URLSearchParams(params).toString();
      let generate_Id = generateId(10);
      customFetch(
        process.env.REACT_APP_URL +
          "/get/loan/document/byhousehold?" +
          queryParams,
        {
          method: "GET",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: localStorage.getItem("in_userid"),
          },
        }
      )
        .then((res) => {
          if (res.headers.get("api_code") > 0) {
            this.setState({
              isErrOpen: true,
              api_error_message: res.headers.get("api_error_message"),
              isSpin: false,
            });
          }
          return res.json();
        })
        .then((json) => {
          console.log(json);

          this.setState({
            isSpin: false,
            LoanDetail: json,
          });
        })
        .catch((error) => {
          console.log("error", error)
          this.setState({
            isSpin: false,
          });
        });
      //alert("Y");
    } else {
      //alert("N");
      this.setState({ isLoan: false });
    }
  }
  render() {
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const { isDisable, isErrOpen, api_error_message, balance } = this.state;
    let data = this.state.items;
    console.log("LoanDetail", this.state.LoanDetail);
    return (
      <>
        {this.state.isSpin ? (
          <div class="preloader">
            <div class="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            this.state.isLogout
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => logout(null, null, true)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>We Have to Log You Out. Kindly Login again</p>
            </div>
          </div>
        </div>
        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isErrOpen: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
            </div>
          </div>
        </div>
        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="disp_msg"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cr_msg_block">
              <span>
                Your current demand has been collected. Would you like to accept
                advance payment?
              </span>
              <br />

              <div class="modal-btn-block">
                <button
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/PaymentTransfer",
                      state: {
                        api_token: api_token,
                        Borrower_Name: this.state.Borrower_Name,
                        od_amt: this.state.Overdue_Amount,
                        od_charge: this.state.Overdue_Charges,
                        cd_amt: this.state.Current_Demand_Amount,
                        hh_no: this.state.hh_id,
                        hh_id: this.state.Household_id,
                        isBalanceZero: true,
                        Loan_os: this.state.Loan_os,
                        Charges_os: this.state.Charges_os,
                      },
                    });
                  }}
                  type="button"
                  className="btn btn-primary col-sm-5"
                  data-dismiss="modal"
                >
                  Continue
                </button>

                <button
                  data-dismiss="modal"
                  onClick={this.searchCustomer}
                  type="button"
                  className="btn btn-danger col-sm-5"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="cr_top_nav">
            <div
              className="back_icon_bg"
              onClick={() => this.props.history.goBack()}
            >
              <img
                src={require("../assets/images/back.png")}
                className="back_icon_img"
              />
            </div>
            <div>
              <a className="navadhan_logo_block" href="#">
                <img
                  src={require("../assets/images/Navadhan_Logo.png")}
                  alt=""
                />
              </a>
            </div>
            <div>
              <a className="acen_logo_block" href="#">
                <img src={require("../assets/images/acen_Logo.png")} alt="" />
              </a>
            </div>
            <a>
              <div className="log-out-deposit">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout(null, null, true)}
                  alt=""
                />
              </div>
            </a>
          </div>
          {this.state.time_flag == 1 ? (
            <div className="maintaenance-container">
              <div className="maintaenance-image">
                <img src="data:image/gif;base64,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" />
              </div>
              <br />
              <div class="content">
                <h3>
                  <span className="maintaenance-text">
                    {" "}
                    Maintenance in progress.
                    <br />
                    <p>{this.state.maintaenance}</p>
                  </span>
                </h3>
                <p>Please stand by</p>
              </div>
            </div>
          ) : (
            <>
              {this.state.maintaenanceBanner ? (
                <>
                  <marquee class="maintaenance-text marquee_data">
                    {this.state.maintaenanceBannerText}
                  </marquee>
                  <div class="maintaenance-text text-center timer_data">
                    {this.state.banner_timer}
                  </div>
                </>
              ) : (
                ""
              )}
              {data.length > 0 ? (
                data.map((item, key) => (
                  <div className="collection-receipt-block" key={key}>
                    <div className="collection_block_header">
                      <div className="title-holder_bg">
                        <h2>Collection Receipt</h2>
                      </div>
                    </div>
                    {/* Below Comment For Hode Foreclosure entry */}
                    {/* <div className="foreclose row">
                      <span className="col-8">Foreclosure entry?</span>
                      <Space direction="vertical">
                        <Switch
                          checkedChildren="On"
                          unCheckedChildren="Off"
                          onChange={(e) => this.handleChangebal(e)}
                        />
                      </Space>
                    </div> */}
                    <div className="htext2">
                      <span className="bluetext">Household ID</span>
                    </div>
                    <div className="col-sm-12">
                      <div className="hhid_holder">{item.Household_Number}</div>
                    </div>
                    <div className="htext2">
                      <span className="bluetext">Loan Disbursement</span>
                    </div>
                    <div className="loan_disbursement_block">
                      <span>Borrower Name</span>

                      <div className="cname_block_pt">
                        <div className="cust_name_pt">
                          {this.titleCase(item.Borrower_Name)}
                        </div>
                        <div className="call_icon" style={{ display: "none" }}>
                          <img
                            src={require("../assets/images/phone-call.png")}
                          />
                        </div>
                      </div>

                      {!this.state.isLoan ? (
                        <div className="amt_date_block">
                          <div>
                            <span className="green_text">Amount</span>
                            <div className="dis_block green_bg">
                              Rs.{" "}
                              {parseFloat(
                                item.Disbursement_Amount
                              ).toLocaleString("en-IN")}
                            </div>
                          </div>
                          <div>
                            <span className="red_text">Date</span>
                            <div className="dis_block red_bg">
                              {item.Disbursement_Date}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {!this.state.isLoan ? (
                      parseInt(this.state.balance) == 0 ||
                      parseInt(this.state.balance) < 0 ? (
                        <div>
                          <div className="htext2">
                            <span className="bluetext">Outstanding</span>
                          </div>
                          <div className="overdue_demand_block">
                            <div className="amt_date_block">
                              <div>
                                <span className="green_text">Amount</span>
                                <div className="dis_block green_bg">
                                  Rs.{" "}
                                  {parseFloat(
                                    this.state.Loan_os
                                  ).toLocaleString("en-IN")}
                                </div>
                              </div>
                              <div>
                                <span className="red_text">Charges</span>
                                <div className="dis_block red_bg">
                                  Rs.{" "}
                                  {parseFloat(
                                    this.state.Charges_os
                                  ).toLocaleString("en-IN")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <div className="total_amt_block">
                              <div className="htext2 text-left">
                                <span className="bluetext">
                                  Overdue Demand{" "}
                                </span>
                              </div>

                              <div className="new_amt_block">
                                <div className="amt_block font-weight-bold">
                                  Rs.{" "}
                                  {parseFloat(
                                    item.Overdue_Amount
                                  ).toLocaleString("en-IN") + " /-"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="total_amt_block">
                              <div className="htext2 text-left">
                                <span className="bluetext">
                                  Current Demand Amount{" "}
                                </span>
                              </div>

                              <div className="new_amt_block">
                                <div className="amt_block font-weight-bold">
                                  Rs.{" "}
                                  {balance
                                    ? parseFloat(balance) -
                                        parseFloat(item.Overdue_Charges) -
                                        parseFloat(item.Overdue_Amount) <
                                      0
                                      ? 0 + " /-"
                                      : parseFloat(balance) -
                                        parseFloat(item.Overdue_Charges) -
                                        parseFloat(item.Overdue_Amount) +
                                        " /-"
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="total_amt_block">
                              <div className="htext2 text-left">
                                <span className="bluetext">Charges </span>
                              </div>

                              <div className="new_amt_block">
                                <div className="amt_block font-weight-bold">
                                  Rs.{" "}
                                  {parseFloat(
                                    item.Overdue_Charges
                                  ).toLocaleString("en-IN") + " /-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="total_amt_block">
                        <div className="htext2 text-left">
                          <span className="bluetext">Loan ID </span>
                        </div>
                        <select
                          className="form-control"
                          name="loan_id"
                          onChange={(e) =>
                            this.setState({ loan_id: e.target.value })
                          }
                        >
                          <option value="">Select Loanid</option>
                          {this.state.LoanDetail.map((loan) => (
                            <option
                              value={
                                loan.loan_account_number + "~" + loan.loan_id
                              }
                            >
                              {loan.loan_account_number}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="collection-receipt-block">
                  <div className="collection_block_header">
                    <div className="title-holder_bg">
                      <h2>
                        Collection Receipt
                        <div
                          className="back_icon_bg"
                          onClick={() => this.props.history.goBack()}
                        >
                          <img
                            src={require("../assets/images/back.png")}
                            className="back_icon_img"
                          />
                        </div>{" "}
                      </h2>
                    </div>
                  </div>

                  <div className="htext2">
                    <span className="bluetext">Household ID</span>
                  </div>
                  <div className="col-sm-12">
                    <input
                      type="text"
                      className="form-control rinput"
                      readOnly
                    />
                  </div>

                  <div className="htext2">
                    <span className="bluetext">Loan Disbursement</span>
                  </div>
                  <div className="loan_disbursement_block">
                    <span>Borrower Name</span>

                    <div className="cname_block_pt">
                      <div className="cust_name_pt"></div>
                      <div className="call_icon" style={{ display: "none" }}>
                        <img src={require("../assets/images/phone-call.png")} />
                      </div>
                    </div>

                    <div className="amt_date_block">
                      <div>
                        Amount
                        <div className="dis_block">Rs.</div>
                      </div>
                      <div>
                        Date
                        <div className="dis_block"></div>
                      </div>
                    </div>
                  </div>

                  <div className="htext2">
                    <span className="bluetext">Overdue Demand</span>
                  </div>

                  <div className="overdue_demand_block">
                    <div className="amt_date_block">
                      <div>
                        Amount
                        <div className="dis_block">Rs. </div>
                      </div>
                      <div>
                        Charges
                        <div className="dis_block">Rs.</div>
                      </div>
                    </div>
                  </div>
                  <div className="total_amt_block">
                    <div className="tamt">
                      <span className="bluetext">Current Demand Amount: </span>
                    </div>

                    <div className="new_amt_block">
                      <div className="amt_block">Rs.</div>
                    </div>
                  </div>
                </div>
              )}

              <div className="button_block col-sm-12">
                <div className="col-sm-12">
                  {this.state.isLoan ? (
                    <button
                      className="btn btn-primary btn-lg btn-block rbtn"
                      disabled={!this.state.loan_id}
                      onClick={(event) => {
                        //alert("It's Loan");
                        this.setState({ isSpin: true });
                        this.props.history.push({
                          pathname: "/PaymentTransfer_Loan",
                          state: {
                            api_token: api_token,
                            Borrower_Name: this.state.Borrower_Name,
                            hh_no: this.state.hh_id,
                            loan_id: this.state.loan_id,
                            hh_id: this.state.Household_id,
                            // od_amt: this.state.Overdue_Amount,
                            // od_charge: this.state.Overdue_Charges,
                            // cd_amt:
                            //   parseFloat(balance) -
                            //   parseFloat(this.state.Overdue_Charges) -
                            //   parseFloat(this.state.Overdue_Amount),
                            // Loan_os: this.state.Loan_os,
                            // Charges_os: this.state.Charges_os,
                          },
                        });
                      }}
                    >
                      Process To Transfer
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary btn-lg btn-block rbtn"
                      disabled={!data.length > 0}
                      onClick={(event) => {
                        if (
                          parseInt(this.state.balance) == 0 ||
                          parseInt(this.state.balance) < 0
                        ) {
                          event.currentTarget.setAttribute(
                            "data-toggle",
                            "modal"
                          );
                          event.currentTarget.setAttribute(
                            "data-target",
                            "#disp_msg"
                          );
                        } else {
                          this.setState({ isSpin: true });
                          this.props.history.push({
                            pathname: "/PaymentTransfer",
                            state: {
                              api_token: api_token,
                              Borrower_Name: this.state.Borrower_Name,
                              od_amt: this.state.Overdue_Amount,
                              od_charge: this.state.Overdue_Charges,
                              cd_amt:
                                parseFloat(balance) -
                                parseFloat(this.state.Overdue_Charges) -
                                parseFloat(this.state.Overdue_Amount),
                              hh_no: this.state.hh_id,
                              hh_id: this.state.Household_id,
                              Loan_os: this.state.Loan_os,
                              Charges_os: this.state.Charges_os,
                            },
                          });
                        }
                      }}
                    >
                      Process To Transfer
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {this.state.flag === 0 && (
        <ChatSupportBtn history={this.props.history} />
        )}
      </>
    );
  }
}

export default withRouter(CollectionReceipt);
